import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PseiNgCustomModule } from '../psei-ng-custom.module';
import { PseicTabGroupComponent } from './pseic-tab-group/pseic-tab-group.component';
import { PseicTabComponent } from './pseic-tab/pseic-tab.component';


@NgModule({
  declarations: [PseicTabGroupComponent, PseicTabComponent],
    imports: [
        CommonModule,
        PortalModule,
        FlexLayoutModule,
        PseiNgCustomModule
    ],
  exports: [PseicTabGroupComponent, PseicTabComponent]
})
export class PseicTabModule { }
